module.exports = __webpack_public_path__ + "img/05.6d430d9e.jpg";